export const ProfileTab = {
  ORDERS: 'siparis-takip',
  NOTIFICATIONS: 'bildirimlerim',
  FAVORITES: 'favorilerim',
  ADDRESSES: 'adreslerim',
  ACCOUNT_INFO: 'kisisel-bilgilerim',
  CHANGE_PASSWORD: 'sifremi-degistir',
};

export type ProfileTabValue = (typeof ProfileTab)[keyof typeof ProfileTab];
